import { useState } from "react";

export default function AuthRegisterUser({ state, onChange, onSuccess, onError, authService }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate passwords match
    if (state.password !== state.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoading(true);
    setError("");

    try {
      // For Cognito, often the username and email are the same
      const attributes = {
        email: state.email || state.username,
        name: state.name,
      };

      const result = await authService.register(state.username, state.password, attributes);
      setLoading(false);

      if (typeof onSuccess === "function") {
        localStorage.setItem("register", state.username);
        onSuccess({ action: "confirm", response: result });
      }
    } catch (err) {
      setLoading(false);
      const errorMessage = err.message || "An error occurred during sign up";
      setError(errorMessage);

      if (typeof onError === "function") {
        onError(err);
      }
    }
  };

  return (
    <div className="mx-auto w-full max-w-md">
      <form onSubmit={handleSubmit} className="mb-4 rounded px-8 pt-6 pb-8">
        <h2 className="text-center">Sign Up</h2>

        <div className="mb-4">
          <label className="mb-2 block text-sm font-bold" htmlFor="username">
            Username
          </label>
          <input
            className="input-text"
            id="username"
            type="text"
            placeholder="Username"
            value={state.username || ""}
            onChange={(e) => onChange("username", e.target.value)}
            autoComplete="username"
            required
          />
        </div>

        <div className="mb-4">
          <label className="mb-2 block text-sm font-bold" htmlFor="name">
            Name
          </label>
          <input
            className="input-text"
            id="name"
            type="text"
            placeholder="Full Name"
            value={state.name || ""}
            onChange={(e) => onChange("name", e.target.value)}
            required
          />
        </div>

        <div className="mb-4">
          <label className="mb-2 block text-sm font-bold" htmlFor="email">
            Email
          </label>
          <input
            className="input-text"
            id="email"
            type="email"
            placeholder="Email"
            value={state.email || ""}
            onChange={(e) => onChange("email", e.target.value)}
            required
          />
        </div>

        <div className="mb-4">
          <label className="mb-2 block text-sm font-bold" htmlFor="password">
            Password
          </label>
          <input
            className="input-text"
            id="password"
            type="password"
            placeholder="******************"
            value={state.password || ""}
            onChange={(e) => onChange("password", e.target.value)}
            autoComplete="new-password"
            required
          />
        </div>

        <div className="mb-6">
          <label className="mb-2 block text-sm font-bold" htmlFor="confirmPassword">
            Confirm Password
          </label>
          <input
            className="input-text"
            id="confirmPassword"
            type="password"
            placeholder="******************"
            value={state.confirmPassword || ""}
            onChange={(e) => onChange("confirmPassword", e.target.value)}
            autoComplete="new-password"
            required
          />
        </div>

        {error && (
          <div
            className="relative mt-4 mb-4 rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700"
            role="alert"
          >
            <span className="block sm:inline">{error}</span>
          </div>
        )}

        <div className="flex items-center justify-end">
          <button
            className={`bg-proof-blue focus:shadow-outline rounded px-4 py-2 font-bold text-white hover:opacity-80 focus:outline-none ${loading ? "cursor-not-allowed opacity-50" : ""}`}
            type="submit"
            disabled={loading}
          >
            {loading ? "Signing up..." : "Sign Up"}
          </button>
        </div>
      </form>
    </div>
  );
}
